import type { ReturnPaymentSpecification } from '@festina/moneyin-general-types/moneyin'
import { type ExcludeString, listUtils } from '@festina-life/core'

export const returnPaymentSpecificationTypes = listUtils.arrayOfAllUnique<
  ExcludeString<ReturnPaymentSpecification['_type']>
>()([
  'ReturnPaymentToLegalEntitySpecification',
  'ReturnPaymentToAccountSpecification',
  'ReturnPaymentToSenderSpecification',
])
